<template>
  <TableLayout>
    <!-- 搜索表单 -->
    <SearchFormCollapse slot="search-form">
      <el-form
        ref="searchForm"
        :model="searchForm"
        label-width="100px"
        inline
        label-position="top"
      >
        <el-col :span="4"
          ><el-form-item label="物料编码" prop="wlbm">
            <el-input
              v-model="searchForm.wlbm"
              placeholder="请输入物料编码"
              @keypress.enter.native="search"
            ></el-input> </el-form-item
        ></el-col>
        <el-col :span="4"
          ><el-form-item label="批次号" prop="pc">
            <el-input
              v-model="searchForm.pc"
              placeholder="请输入批次号"
              @keypress.enter.native="search"
            ></el-input> </el-form-item
        ></el-col>
        <el-col :span="4"
          ><el-form-item label="物料描述" prop="wlms">
            <el-input
              v-model="searchForm.wlms"
              placeholder="请输入物料描述"
              @keypress.enter.native="search"
            ></el-input> </el-form-item
        ></el-col>
        <el-col :span="4"
          ><el-form-item label="订单单位" prop="dddw">
            <el-input
              v-model="searchForm.dddw"
              placeholder="请输入订单单位"
              @keypress.enter.native="search"
            ></el-input>
          </el-form-item></el-col>
          <el-col :span="4"
          ><el-form-item label="供应商" prop="gysmc">
            <el-input
              v-model="searchForm.gysmc"
              placeholder="请输入供应商"
              @keypress.enter.native="search"
            ></el-input> </el-form-item
        ></el-col>
        <section>
          <div class="btnBox">
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button @click="reset">重置</el-button>
          </div>
        </section>
      </el-form>
    </SearchFormCollapse>
    <!-- dialog -->
    <PublicDialog :dialogData="dialogData">
      <template #UploadTem>
        <Upload ref="upload" :uploadData="uploadData" />
      </template>
      <template #print>
        <p style="font-size: 18px; text-align: center">是否打印成功?</p>
      </template>
      <template #importResult>
        <ImportResult
          v-if="ImportResultData.length"
          :ImportResultData="ImportResultData"
        />
      </template>
      <template #customization>
        <Customization
          v-if="isCustomization"
          ref="customization"
          :rowData="rowData"
          :colsData='dataSource.cols'
        />
      </template>
    </PublicDialog>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar">
        <li style="margin-right: 20px">
          启用全局配置&nbsp;:&emsp;
          <el-switch
            v-model="isGlobal"
            active-color="#13ce66"
            inactive-color="gray"
          >
          </el-switch>
          &emsp;标签数量&nbsp;:&emsp;
          <el-input-number
            v-model="globalPrintConfig.copies"
            :disabled="!isGlobal"
            :min="1"
            :max="20"
          ></el-input-number>
          <!-- &emsp;物资数量&nbsp;:&emsp;
          <el-input-number
            v-model="globalPrintConfig.num"
            :disabled="!isGlobal"
            :min="0"
            :precision="3"
            :step="1"
          ></el-input-number> -->
        </li>
        <li v-if="print_manufacturers.includes('DeTong')">
          <el-button type="primary" @click="handleClickPrint">打印</el-button>
        </li>
        <li v-if="print_manufacturers.includes('JiaBo')">
          <el-button type="primary" @click="handleClickPrintJiaBo">佳博打印</el-button>
        </li>
        <li>
          <el-button
            type="primary"
            icon="el-icon-upload"
            @click="handleClickUploadTemplate"
            >导入数据</el-button
          >
        </li>
        <!-- <li>
          <el-button
            type="primary"
            @click="$refs.ImportDataAddEdit.open('新增数据')"
            icon="el-icon-plus"
          >
            新建
          </el-button>
        </li> -->
        <li>
          <el-button
            type="primary"
            icon="el-icon-delete"
            @click="handleClickClear"
            >一键清空</el-button
          >
        </li>
        <li>
          <el-button @click="deleteByIdInBatch" icon="el-icon-delete"
            >删除</el-button
          >
        </li>
      </ul>
      <PublicTable
        ref="dialogTable"
        :data-source="dataSource"
        @sizeChange="changeSize"
        @currentChange="changeNum"
        @handleSelection="publicTableHandleSelectionChange"
      >
        <template #dddw="{ scope }">
          {{ scope.dddw }}
        </template>
        <!-- <template #num="{ scope }">
          <el-input-number
            v-model="scope.num"
            :min="0"
            :disabled="isGlobal"
            :precision="3"
            :step="1"
          ></el-input-number>
        </template> -->
        <template #remarks="{ scope }">
          <el-input
            v-model="scope.remarks"
            placeholder="请输入备注"
            maxlength="150"
            v-trim
          ></el-input>
        </template>
        <template #copies="{ scope }">
          <el-input-number
            v-model="scope.copies"
            :min="1"
            :max="20"
            :disabled="isGlobal"
          ></el-input-number>
        </template>
        <!-- 连云港 -->
        <template #storageLocationProject="{ scope }">
          <el-input
            v-model="scope.storageLocationProject"
            placeholder="请输入库位"
            maxlength="150"
            v-trim
          ></el-input>
        </template>
        <template #materialsNum="{ scope }">
          <el-input-number
            v-model="scope.materialsNum"
            :min="0"
            :precision="3"
            :step="1"
          ></el-input-number>
        </template>
        <!-- 融合 -->
        <template #createTime="{ scope }">
          <el-date-picker
            style="width: 100%"
            v-model="scope.createTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            align="right"
            type="datetime"
            placeholder="请选择入库日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </template>
        <template #htsl="{ scope }">
          <el-input-number
            v-model="scope.htsl"
            :min="0"
            :precision="3"
            :step="1"
          ></el-input-number>
        </template>

        <template #stock="{ scope }">
          <el-input
            v-model="scope.stock"
            placeholder="请输入托盘号"
            maxlength="150"
            v-trim
          ></el-input>
        </template>
        <template #shippingSpace="{ scope }">
          <el-input
            v-model="scope.shippingSpace"
            placeholder="请输入仓位号"
            maxlength="150"
            v-trim
          ></el-input>
        </template>
        <template #factoryCode="{ scope }">
          <el-input
            v-model="scope.factoryCode"
            placeholder="请输入出厂编码"
            maxlength="150"
            v-trim
          ></el-input>
        </template>
        <template #date="{ scope }">
          <el-date-picker
            style="width: 100%"
            v-model="scope.date"
            value-format="yyyy-MM-dd"
            align="right"
            type="date"
            placeholder="请选择日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </template>
        <template #numberDisks="{ scope }">
          <el-input-number
            v-model="scope.numberDisks"
            :min="0"
            :precision="3"
            :step="1"
          ></el-input-number>
        </template>
        <template #quantityIssued="{ scope }">
          <el-input-number
            v-model="scope.quantityIssued"
            :min="0"
            :precision="3"
            :step="1"
          ></el-input-number>
        </template>
        <template #balanceQuantity="{ scope }">
          <el-input-number
            v-model="scope.balanceQuantity"
            :min="0"
            :precision="3"
            :step="1"
          ></el-input-number>
        </template>
      </PublicTable>  
    </template>
    <!-- 新建/修改 -->
    <ImportDataAddEdit ref="ImportDataAddEdit" @success="newPage" />
  </TableLayout>
</template>

<script>
import BaseTable from "@/components/base/BaseTable";
import TableLayout from "@/layouts/TableLayout";
import SearchFormCollapse from "@/components/common/SearchFormCollapse";
import Pagination from "@/components/common/Pagination";
import ImportDataAddEdit from "./add_edit";
import {
  printApi,
  isPrintSuccessApi,
  uploadTemApi,
  fetchList,
  deleteByIdInBatch,
  getListFiledApi,
  clearAllApi
} from "@/api/import_data";
import Upload from "@/components/public_com/upload";
import ImportResult from "./importResult.vue";
// import {
//   returnPrintTemplate,
//   printFn,
// } from "@/views/custom_data_management/printTemplate";
import { findByDictCode } from "@/api/system/dictData";
import cols from "./model";
import { mapState } from "vuex";
import Customization from "../synchronous_data/customization";
export default {
  name: "import_data",
  extends: BaseTable,
  components: {
    SearchFormCollapse,
    TableLayout,
    Pagination,
    ImportDataAddEdit,
    Upload,
    ImportResult,
    Customization
  },
  data() {
    return {
      pickerOptions: {
        // disabledDate(time) {
        //   return new Date().getFullYear() < time.getFullYear()||new Date().getFullYear() > time.getFullYear();
        //   // return time.getTime() > Date.now();
        // },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      rowData: {},
      isCustomization: false,
      ImportResultData: [],
      optionArr: [],
      uploadData: {
        // exportExcelApi,
        // exportExcelTemApi,
        accept: [".xls", ".xlsx"],
        isHaveExportTemBtn: true,
        temUrl: "/template.xlsx",
        temName: "模拟导入模板(标签打印系统).xlsx",
      },
      isGlobal: false,
      globalPrintConfig: {
        copies: 1,
        num: 0,
      },
      // 搜索
      searchForm: {
        wlbm: "",
        pc: "",
        wlms: "",
        htsl: "",
        dddw: "",
        gysmc:''
      },
      // dialog数据源
      dialogData: [
        {
          data: [], //传递数据slot
          name: "UploadTem", //dialog插槽名
          isDialog: false, //是否显示dialog
          isBtn: true, //是否显示cancel和confirm按钮
          title: "导入数据", //header提示内容
          width: "400px", //dialog宽度
          colseFn: this.closeFnUploadTem,
          // handleClickCancel: this.handleClickUploadTemCancel, //dialog取消
          handleClickConfirm: this.handleClickUploadTemConfirm, //dialog确定
          iconCancel: "el-icon-circle-close",
          iconConfirm: "el-icon-circle-check",
          isLoadingConfirm: false,
        },
        {
          data: [], // 传递数据slot
          name: "print", // dialog插槽名
          key: "print", // 区分唯一性key
          isDialog: false, // 是否显示dialog
          isBtn: true, // 是否显示cancel和confirm按钮
          title: "打印", // header提示内容
          width: "20%", // dialog宽度
          lockScroll: true,
          closeModal: false,
          closePressEscape: false,
          showClose: false,
          cancelBtnName: "失败",
          confirmBtnName: "成功",
          handleClickCancel: this.handleClickPrintCancel, // dialog取消
          handleClickConfirm: this.handleClickPrintConfirm, // dialog确定
        },
        {
          data: [], //传递数据slot
          name: "importResult", //dialog插槽名
          isDialog: false, //是否显示dialog
          isBtn: false, //是否显示cancel和confirm按钮
          title: "导入结果", //header提示内容
          width: "60%", //dialog宽度
          colseFn: this.closeFnImportResult,
          // handleClickCancel: this.handleClickUploadTemCancel, //dialog取消
          handleClickConfirm: this.handleClickImportResultConfirm, //dialog确定
          iconCancel: "el-icon-circle-close",
          iconConfirm: "el-icon-circle-check",
          isLoadingConfirm: false,
        },
        {
          data: [], // 传递数据slot
          name: "customization", // dialog插槽名
          key: "customization", // 区分唯一性key
          isDialog: false, // 是否显示dialog
          isBtn: true, // 是否显示cancel和confirm按钮
          title: "定制化", // header提示内容
          width: "80%", // dialog宽度
          // lockScroll: true,
          // closeModal: false,
          // closePressEscape: false,
          // showClose: false,
          cancelBtnName: "取消",
          confirmBtnName: "打印",
          colseFn: this.closeFnCustomization,
          // handleClickCancel: this.handleClickCustomizationCancel, // dialog取消
          handleClickConfirm: this.handleClickCustomizationConfirm, // dialog确定
          isCustom:true,
          isConfirmBtnHide:false,
          handleClickCustom:this.handleClickCustomJiaBo,
          customBtnName:'佳博打印'
        },
      ],

      dataSource: {
        topButtons: [
          //  {
          //    name: '添加群组项', //按钮名称
          //    key: 1,  // 唯一标识符
          //   //  permission: 2010106, // 权限点
          //   //  type: '',  // 使用element自带按钮类型
          //    bgColor: 'skyblue', // 自定义背景色
          //    handleClick: this.handleEdit, //自定义事件
          //    disabled:false,//是否禁用
          //    loading:false,//是否加载中状态
          //  },
        ],
        data: [], // 表格数据
        cols:[], // 表格的列数据
        publicTableHandleSelectionChange: (val) => {}, // 点击行选中多选返回选中数组
        isSelection: true, // 表格有多选时设置
        isSelectionFixed: true, //表格多选固定
        isMultipleChoice: false, // 是否单选
        isReserve: false, // 是否分页多选
        isOperation: true, // 表格有操作列时设置
        isIndex: true, // 列表序号
        loading: false, // loading
        pageData: {
          total: 0, // 总条数
          pageSize: 10, // 每页数量
          pageNum: 1, // 页码
          pageSizes: [10, 20, 30, 40], // 每页数量
        },
        operation: {
          // 表格有操作列时设置
          label: "操作", // 列名
          width: "200", // 根据实际情况给宽度
          data: [
          {
              label: "详情",
              type: "button",
              style: "text",
              icon: "el-icon-view",
              handleRow: this.handleClickView,
            },
            {
              label: "修改",
              type: "button",
              style: "text",
              icon: "el-icon-edit",
              handleRow: this.handleClickDetails,
            },
            {
              label: "定制化",
              type: "button",
              style: "text",
              icon: "el-icon-collection-tag",
              handleRow: this.handleClickCustomization,
            },
          ],
        },
      },
      pageReqParams: {
        page: 1,
        capacity: 10,
        model: {},
        sorts: null,
      },

      checkedSelectArr: [],
      printData: [],
    };
  },
  computed: {
    ...mapState(["templateObj","print_manufacturers"]),
  },
  watch: {
    templateObj: {
      handler(newVal) {
        console.log(newVal)
        this.dataSource.loading = true;
        getListFiledApi({
          templateKey: newVal?.templateKey,
          key: "1",
        }).then(res=>{
          this.dataSource.cols=res||[];
        })
        .finally(()=>{
          this.dataSource.loading = false;
        })
      },
      immediate:true
    },
    print_manufacturers: {
      handler(newVal) {
        this.dialogData[3].isConfirmBtnHide=!(newVal.includes('DeTong'));
        this.dialogData[3].isCustom=newVal.includes('JiaBo');
      },
      immediate:true
    },
  },
  methods: {
    handleClickClear(){
      this.$confirm('此操作将一键清空【导入物资】的所有数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        clearAllApi()
        .then(res=>{
          this.$message({
            type: 'success',
            message: res||'一键清空成功!'
          });
        })
        .catch(err=>{
          this.$message({type:'error',message:err.message})
        })
        .finally(()=>{
          this.newPage()
        })
      }).catch(() => {});
    },
    // 点击打印
    handleClickPrintJiaBo() {
      if (this.checkedSelectArr.length) {
        if (this.isGlobal) {
          let arr=[];
          this.checkedSelectArr.forEach((item) => {
            for (let i = 0; i < this.globalPrintConfig.copies; i++) {
              arr.push({
                ...item,
                num: this.globalPrintConfig.num,
              }) 
            }
          });

          sessionStorage.setItem('printArr',JSON.stringify(arr))
          sessionStorage.setItem('printerParams',JSON.stringify({
            templateId:this.templateObj?.id,
            templateType:"20",
            dataType:"10",
            matPrintVoList:this.checkedSelectArr.map(item=>({...item,copies:this.globalPrintConfig.copies}))
          }))
          let routeData = this.$router.resolve({
              name: "printTem",
              query: {},
          });
          window.open(routeData.href.replace("/#/#/", "/#/"), "_blank");

          this.newPage();
          this.isGlobal=false;
          this.globalPrintConfig={
            copies:1,
            num:0
          }
        } else {
          let arr=[];
          this.checkedSelectArr.forEach((item) => {
            for (let i = 0; i < item.copies; i++) {
              arr.push(item)
            }
          });

          sessionStorage.setItem('printArr',JSON.stringify(arr))
          sessionStorage.setItem('printerParams',JSON.stringify({
            templateId:this.templateObj?.id,
            templateType:"20",
            dataType:"10",
            matPrintVoList:this.checkedSelectArr
          }))
          let routeData = this.$router.resolve({
              name: "printTem",
              query: {},
          });
          window.open(routeData.href.replace("/#/#/", "/#/"), "_blank");

          this.newPage();
          this.isGlobal=false;
          this.globalPrintConfig={
            copies:1,
            num:0
          }
        }
      } else {
        this.$message({
          type: "warning",
          message: "请选择需要打印的数据",
        });
      }
    },
    closeFnCustomization() {
      this.isCustomization = false;
    },
    handleClickCustomJiaBo(item, index) {
      let customizationConfirmData = this.$refs.customization.apiData;
      let arr=[];
      customizationConfirmData&&customizationConfirmData.forEach((item) => {
        arr.push({
          ...item,
        })
      });

      setTimeout(() => {
        sessionStorage.setItem('printArr',JSON.stringify(arr))
        sessionStorage.setItem('printerParams',JSON.stringify({
          templateId:this.templateObj?.id,
          templateType:"20",
          dataType:"10",
          matPrintVoList:customizationConfirmData
        }))
        let routeData = this.$router.resolve({
            name: "printTem",
            query: {},
        });
        window.open(routeData.href.replace("/#/#/", "/#/"), "_blank");
      }, 300);

      this.dialogData[index].isDialog = false;
    },
    handleClickCustomizationConfirm(item, index) {
      let customizationConfirmData = this.$refs.customization.apiData;
      let arr=[];
      customizationConfirmData&&customizationConfirmData.forEach((item) => {
        arr.push({
          ...item,
        })
      });

      setTimeout(() => {
        sessionStorage.setItem('printArr',JSON.stringify(arr))
        sessionStorage.setItem('printerParams',JSON.stringify({
          templateId:this.templateObj?.id,
          templateType:"10",
          dataType:"10",
          matPrintVoList:customizationConfirmData
        }))
        let routeData = this.$router.resolve({
            name: "print",
            query: {},
        });
        window.open(routeData.href.replace("/#/#/", "/#/"), "_blank");
      }, 300);

      this.dialogData[index].isDialog = false;
    },
    handleClickCustomization(index, row, label) {
      this.rowData = { ...row };
      this.isCustomization = true;
      this.dialogData[3].isDialog = true;
    },
    handleClickView(index, row, label) {
      let dom = this.$refs.ImportDataAddEdit;
      dom.$refs.form && dom.$refs.form.resetFields();
      dom.open("查看详情", row,false);
    },
    handleClickDetails(index, row, label) {
      let dom = this.$refs.ImportDataAddEdit;
      dom.$refs.form && dom.$refs.form.resetFields();
      dom.open("修改", row);
    },
    closeFnImportResult() {},
    handleClickImportResultConfirm(item, index, confirmFn) {
      confirmFn(index);
    },
    //dialog关闭回调
    closeFnUploadTem() {
      this.$refs.upload.fileList = [];
    },
    //上传模板confirm
    handleClickUploadTemConfirm(item, index, confirmFn) {
      if (this.$refs.upload.fileList.length) {
        this.dialogData[index].isLoadingConfirm = true;
        //将二进制文件流利用formData进行上传
        const formData = new FormData();
        formData.append("file", this.$refs.upload.fileList[0].raw);
        // console.log(this.$refs.upload.fileList[0].raw);
        // console.log(formData.getAll("file"));
        //携带指定请求头
        uploadTemApi(formData)
          .then((res) => {
            this.$message({
              type: "success",
              message: "上传模板成功" || res.message,
            });
            if (res.code == 500) {
            } else {
              this.ImportResultData = res;
              this.dialogData[2].isDialog = true;
            }
          })
          .catch((err) => {
            this.$message({ type: "error", message: err.message });
          })
          .finally(() => {
            this.$refs.upload.fileList = [];
            this.dialogData[index].isLoadingConfirm = false;
            confirmFn(index);
            this.search();
          });
      } else {
        this.$message({ type: "info", message: "请选择上传文件" });
      }
    },
    //导入数据
    handleClickUploadTemplate() {
      this.dialogData[0].isDialog = true;
    },
    // 是否打印成功dialog取消
    handleClickPrintCancel(item, index) {
      const arr = [];
      this.printData.length &&
        this.printData.forEach((item) => {
          item.forEach((objItem) => {
            arr.push({
              id: objItem.tbBaseMaterialDetailsInfo.materialContractExecId,
              rfidCode: objItem.tbBaseMaterialDetailsInfo.rfidCode,
            });
          });
        });
      isPrintSuccessApi(arr).then((res) => {
        this.$message({ type: "success", message: "确认完成" });
      });
      this.dialogData[index].isDialog = false;
      this.newPage();
    },
    // 是否打印成功dialog确定
    handleClickPrintConfirm(item, index) {
      this.dialogData[index].isDialog = false;
      this.newPage();
    },
    // 点击打印
    handleClickPrint() {
      if (this.checkedSelectArr.length) {
        if (this.isGlobal) {
          let arr=[];
          this.checkedSelectArr.forEach((item) => {
            for (let i = 0; i < this.globalPrintConfig.copies; i++) {
              arr.push({
                ...item,
                num: this.globalPrintConfig.num,
              }) 
            }
          });

          sessionStorage.setItem('printArr',JSON.stringify(arr))
          sessionStorage.setItem('printerParams',JSON.stringify({
            templateId:this.templateObj?.id,
            templateType:"10",
            dataType:"10",
            matPrintVoList:this.checkedSelectArr.map(item=>({...item,copies:this.globalPrintConfig.copies}))
          }))
          let routeData = this.$router.resolve({
              name: "print",
              query: {},
          });
          window.open(routeData.href.replace("/#/#/", "/#/"), "_blank");

          this.newPage();
          this.isGlobal=false;
          this.globalPrintConfig={
            copies:1,
            num:0
          }
        } else {
          let arr=[];
          this.checkedSelectArr.forEach((item) => {
            for (let i = 0; i < item.copies; i++) {
              arr.push(item)
            }
          });

          sessionStorage.setItem('printArr',JSON.stringify(arr))
          sessionStorage.setItem('printerParams',JSON.stringify({
            templateId:this.templateObj?.id,
            templateType:"10",
            dataType:"10",
            matPrintVoList:this.checkedSelectArr
          }))
          let routeData = this.$router.resolve({
              name: "print",
              query: {},
          });
          window.open(routeData.href.replace("/#/#/", "/#/"), "_blank");

          this.newPage();
          this.isGlobal=false;
          this.globalPrintConfig={
            copies:1,
            num:0
          }
        }
      } else {
        this.$message({
          type: "warning",
          message: "请选择需要打印的数据",
        });
      }
    },
    deleteByIdInBatch() {
      if (this.checkedSelectArr.length) {
        this.$confirm("此操作将永久删除该选中文件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            deleteByIdInBatch(
              this.checkedSelectArr.map((item) => item.id).join(",")
            )
              .then((res) => {
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
              })
              .catch((e) => {
                this.$message({
                  type: "error",
                  message: e.message,
                });
              })
              .finally(() => {
                this.deleteAfter(this.checkedSelectArr.length);
                this.newPage();
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "warning",
          message: "请选择需要删除的数据",
        });
      }
    },
    deleteAfter(delLength) {
      if (this.dataSource.data.length - delLength == 0) {
        this.changeNum(
          this.pageReqParams.page - 1 == 0 ? 1 : this.pageReqParams.page - 1
        );
      }
    },
    search() {
      this.pageReqParams.model = this.searchForm;
      this.newPage();
    },
    reset() {
      for (let key in this.searchForm) {
        this.searchForm[key] = "";
      }
      this.pageReqParams.model = this.searchForm;
      this.newPage();
    },
    // 详情表格选中数据
    publicTableHandleSelectionChange(val) {
      this.checkedSelectArr = val;
    },
    // 改变每页查询数量
    changeSize(size) {
      this.pageReqParams.page = this.dataSource.pageData.pageNum = 1;
      this.pageReqParams.capacity = this.dataSource.pageData.pageSize = size;
      this.newPage();
    },
    // 分页页码
    changeNum(pageNum) {
      this.pageReqParams.page = this.dataSource.pageData.pageNum = pageNum;
      this.newPage();
    },
    // 请求dialog列表项
    newPage() {
      this.dataSource.loading = true;
      fetchList(this.pageReqParams).then((res) => {
        this.dataSource.data =
          (res.records &&
            res.records.map((item) => ({
              ...item,
              copies: 1,
              materialsNum:item.materialsNum-0 || 0,
              htsl:item.htsl-0 || 0,
              numberDisks: item.numberDisks-0 || 0,
              quantityIssued: item.quantityIssued-0 || 0,
              balanceQuantity: item.balanceQuantity-0 || 0,
              // date:new Date().getFullYear() +  "-" +(new Date().getMonth() + 1).toString().padStart(2, "0") +  "-" + new Date().getDate().toString().padStart(2, "0")
            }))) ||
          [];
        this.dataSource.pageData.total = res.total;
        this.dataSource.loading = false;
      });
    },
  },
  created() {
    this.newPage();
  },
};
</script>

<style>
.el-upload-list__item {
  transition: none !important;
}
</style>
<style lang="scss" scoped>
.btnBox {
  line-height: 114px;
}
.box {
  position: absolute;
  left: 10px;
  bottom: 20px;
}
</style>
